import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { Modal, Form, Radio, Button, Table, Space, Descriptions } from "antd";
import { useMutation } from "@tanstack/react-query";
import { hostname } from "../hooks/useEndeavour";

import axios from "axios";

const MessageStatusModal = forwardRef((props, ref) => {
  const [data, setData] = useState();
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const messageStatus = useMutation({
    mutationFn: (data) => {
      return axios.post(`${hostname}/pa-alliance/user/contact/status`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
    },
  });
  const updateStatus = (fromData) => {
    setLoading(true);
    fromData.id = data.id;
    messageStatus.mutate(fromData, {
      onSuccess: () => {
        setLoading(false);
        form.resetFields();
        setVisible(false);
        props.onChange();
      },
      onError: (error) => {
        console.error("Error updating message status:", error);
        setLoading(false);
      },
    });
  };

  useImperativeHandle(ref, () => ({
    openModal: (data) => {
      setVisible(true);
      setData(data);
    },
    closeModal: () => {
      setVisible(false);
    },
  }));

  return (
    <Modal
      title="Add"
      visible={visible}
      onCancel={() => {
        form.resetFields();
        setVisible(false);
      }}
      footer={null}
    >
      <Descriptions layout="vertical" column={2}>
        <Descriptions.Item label="Sender">{data?.sender}</Descriptions.Item>
        <Descriptions.Item label="To">{data?.to}</Descriptions.Item>
        <Descriptions.Item label="Type">{data?.type}</Descriptions.Item>
        <Descriptions.Item label="Status">{data?.status}</Descriptions.Item>
        <Descriptions.Item label="Subject">{data?.subject}</Descriptions.Item>
        <Descriptions.Item label="Content">{data?.content}</Descriptions.Item>
        <Descriptions.Item label="Date">{data?.date}</Descriptions.Item>
        <Descriptions.Item label="Created By">{data?.created_by}</Descriptions.Item>
      </Descriptions>
      <Form form={form} layout="vertical" onFinish={updateStatus}>
        <Form.Item
          label="Status"
          name={"status"}
          rules={[
            {
              required: true,
              message: "Please select Status !",
            },
          ]}
        >
          <Radio.Group
            options={[
              {
                value: "hello",
                label: "Hello",
              },

              {
                value: "follow_up",
                label: "Follow Up",
              },

              {
                value: "no_reply",
                label: "No Reply",
              },
              {
                value: "escalate",
                label: "Escalate",
              },
              { value: "campaign", label: "Campaign" },
              {
                value: 'closed',
                label: "Closed",
              },
            ]}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default MessageStatusModal;
